// Clipboard helper, async Clipboard API with an execCommand fallback for
// contexts where navigator.clipboard is unavailable or blocked. Returns true on
// success so callers can flip a transient "Copied" label.
export async function copyText(text: string): Promise<boolean> {
  if (!/^https?:/.test(text) && !text) return false;
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return true; }
  } catch { /* fall through to execCommand */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.focus(); ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch { return false; }
}
